import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { headingErrorState } from '../../../Reporter/state';
import type { SlateContent } from '../../../Reporter/types';
import { hasDuplicateHeadingsInNode } from './utils';

// This is the source of truth for submit/save gating and warning visibility.
// It intentionally derives from content (not headingError marks) so validity does
// not depend on plugin normalization timing.
export const useSyncHeadingErrorState = (content: SlateContent): void => {
  const [, setHasHeadingError] = useRecoilState(headingErrorState);

  useEffect(() => {
    setHasHeadingError(hasDuplicateHeadingsInNode({ children: content }));
  }, [content, setHasHeadingError]);
};
